// import React from 'react';
// import { Link } from 'react-router-dom';
// import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube, FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
// import { motion } from 'framer-motion';

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   const footerLinks = {
//     quickLinks: [
//       { name: 'Home', path: '/' },
//       { name: 'About Us', path: '/about' },
//       { name: 'Services', path: '/services' },
//       { name: 'Calculators', path: '/calculators' },
//       { name: 'Blogs', path: '/blogs' },
//       { name: 'Contact Us', path: '/contact' },
//     ],
//     services: [
//       'Mutual Funds',
//       'Health Insurance',
//       'Life Insurance',
//       'Retirement Planning',
//       'Home Loans',
//       'Tax Planning',
//     ],
//   };

//   return (
//     <footer className="bg-gray-900 text-gray-300 pt-12 pb-6">
//       <div className="container-custom">
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
//           {/* Company Info */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//           >
//             <div className="flex items-center space-x-3 mb-4">
//               <div className="w-10 h-10 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center">
//                 <span className="text-white font-bold">W</span>
//               </div>
//               <h3 className="text-white text-xl font-bold">Wisdom Consultancy</h3>
//             </div>
//             <p className="mb-4 text-sm">
//               Secure your financial future with expert investment advice and personalized solutions.
//               We help you achieve your financial goals with trust and transparency.
//             </p>
//             <div className="flex space-x-4">
//               <a href="#" className="hover:text-white transition-colors"><FaFacebook size={20} /></a>
//               <a href="#" className="hover:text-white transition-colors"><FaTwitter size={20} /></a>
//               <a href="#" className="hover:text-white transition-colors"><FaLinkedin size={20} /></a>
//               <a href="#" className="hover:text-white transition-colors"><FaInstagram size={20} /></a>
//               <a href="#" className="hover:text-white transition-colors"><FaYoutube size={20} /></a>
//             </div>
//           </motion.div>

//           {/* Quick Links */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.1 }}
//           >
//             <h3 className="text-white text-xl font-bold mb-4">Quick Links</h3>
//             <ul className="space-y-2">
//               {footerLinks.quickLinks.map((link) => (
//                 <li key={link.name}>
//                   <Link to={link.path} className="hover:text-white transition-colors text-sm">
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* Our Services */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//           >
//             <h3 className="text-white text-xl font-bold mb-4">Our Services</h3>
//             <ul className="space-y-2">
//               {footerLinks.services.map((service) => (
//                 <li key={service}>
//                   <span className="text-sm hover:text-white transition-colors cursor-pointer">
//                     {service}
//                   </span>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* Contact Info */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.3 }}
//           >
//             <h3 className="text-white text-xl font-bold mb-4">Contact Info</h3>
//             <ul className="space-y-3">
//               <li className="flex items-start space-x-3 text-sm">
//                 <FaMapMarkerAlt className="mt-1 flex-shrink-0" />
//                 <span>E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010</span>
//               </li>
//               <li className="flex items-center space-x-3 text-sm">
//                 <FaPhone />
//                 <span>9726344477, 9726766777</span>
//               </li>
//               <li className="flex items-center space-x-3 text-sm">
//                 <FaEnvelope />
//                 <span>Wisdom2secure@gmail.com</span>
//               </li>
//               <li className="flex items-start space-x-3 text-sm">
//                 <FaClock />
//                 <span>Mon-Sat: 10:00 AM - 7:00 PM<br />Sunday: Closed</span>
//               </li>
//             </ul>
//           </motion.div>
//         </div>

//         {/* Bottom Bar */}
//         <div className="border-t border-gray-800 pt-6 text-center text-sm">
//           <p>&copy; {currentYear} Wisdom Consultancy. All rights reserved. | Designed with ❤️ for your financial success</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

// import React from 'react';
// import { Link } from 'react-router-dom';
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
//   FaEnvelope,
//   FaPhoneAlt,
//   FaMapMarkerAlt,
//   FaClock,
// } from 'react-icons/fa';
// import { motion } from 'framer-motion';

// const logoImage = '/images/logo.png';

// const Footer = () => {
//   const currentYear = new Date().getFullYear();

//   const quickLinks = [
//     { name: 'Home', path: '/' },
//     { name: 'About Us', path: '/about' },
//     { name: 'Services', path: '/services' },
//     { name: 'Calculators', path: '/calculators' },
//     { name: 'Blogs', path: '/blogs' },
//     { name: 'Contact Us', path: '/contact' },
//   ];

//   const services = [
//     'Mutual Funds',
//     'Life Insurance',
//     'Health Insurance',
//     'Retirement Planning',
//     'Home Loans',
//     'Tax Planning',
//   ];

//   return (
//     <footer className="bg-[#0f172a] text-gray-300 pt-14 pb-6">
//       <div className="container-custom">
//         {/* Main Footer */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-10 border-b border-white/10">

//           {/* Company Info */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5 }}
//           >
//             <Link to="/" className="flex items-center gap-3 mb-5">
//               <img
//                 src={logoImage}
//                 alt="Wisdom Consultancy"
//                 className="w-14 h-14 object-contain"
//               />

//               <div>
//                 <h3 className="text-white text-xl font-bold">
//                   Wisdom Consultancy
//                 </h3>

//                 <p className="text-xs text-gray-400 tracking-widest">
//                   SECURE YOUR FUTURE
//                 </p>
//               </div>
//             </Link>

//             <p className="text-sm leading-7 text-gray-400 mb-5">
//               We provide trusted financial planning, investment advisory,
//               insurance solutions, and wealth management services to help
//               individuals and families achieve long-term financial security.
//             </p>

//             {/* Social Icons */}
//             <div className="flex items-center gap-3">
//               {[
//                 {
//                   icon: <FaFacebookF />,
//                   link: '#',
//                 },
//                 {
//                   icon: <FaInstagram />,
//                   link: '#',
//                 },
//                 {
//                   icon: <FaLinkedinIn />,
//                   link: '#',
//                 },
//                 {
//                   icon: <FaYoutube />,
//                   link: '#',
//                 },
//               ].map((social, index) => (
//                 <a
//                   key={index}
//                   href={social.link}
//                   target="_blank"
//                   rel="noreferrer"
//                   className="w-10 h-10 rounded-full bg-white/10 hover:bg-blue-600 flex items-center justify-center transition-all duration-300 hover:scale-110"
//                 >
//                   {social.icon}
//                 </a>
//               ))}
//             </div>
//           </motion.div>

//           {/* Quick Links */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.1 }}
//           >
//             <h3 className="text-white text-xl font-semibold mb-5">
//               Quick Links
//             </h3>

//             <ul className="space-y-3">
//               {quickLinks.map((link) => (
//                 <li key={link.name}>
//                   <Link
//                     to={link.path}
//                     className="text-gray-400 hover:text-white transition-all duration-300 text-sm"
//                   >
//                     {link.name}
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* Services */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.2 }}
//           >
//             <h3 className="text-white text-xl font-semibold mb-5">
//               Our Services
//             </h3>

//             <ul className="space-y-3">
//               {services.map((service, index) => (
//                 <li
//                   key={index}
//                   className="text-sm text-gray-400 hover:text-white transition-all duration-300 cursor-pointer"
//                 >
//                   {service}
//                 </li>
//               ))}
//             </ul>
//           </motion.div>

//           {/* Contact Info */}
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.5, delay: 0.3 }}
//           >
//             <h3 className="text-white text-xl font-semibold mb-5">
//               Contact Info
//             </h3>

//             <ul className="space-y-5 text-sm">

//               <li className="flex gap-3">
//                 <FaMapMarkerAlt className="mt-1 text-blue-400 flex-shrink-0" />
//                 <a
//                   href="https://maps.google.com"
//                   target="_blank"
//                   rel="noreferrer"
//                   className="hover:text-white transition-colors"
//                 >
//                   E-44, Vasant Vihar Society,
//                   <br />
//                   GIDC - Vadsar Road,
//                   <br />
//                   Vadodara - 390010
//                 </a>
//               </li>

//               <li className="flex items-center gap-3">
//                 <FaPhoneAlt className="text-blue-400" />
//                 <a
//                   href="tel:9726344477"
//                   className="hover:text-white transition-colors"
//                 >
//                   9726344477
//                 </a>
//               </li>

//               <li className="flex items-center gap-3">
//                 <FaEnvelope className="text-blue-400" />
//                 <a
//                   href="mailto:wisdom2secure@gmail.com"
//                   className="hover:text-white transition-colors"
//                 >
//                   wisdom2secure@gmail.com
//                 </a>
//               </li>

//               <li className="flex gap-3">
//                 <FaClock className="mt-1 text-blue-400 flex-shrink-0" />
//                 <span>
//                   Mon - Sat : 10:00 AM - 7:00 PM
//                   <br />
//                   Sunday : Closed
//                 </span>
//               </li>
//             </ul>
//           </motion.div>
//         </div>

//         {/* Bottom Footer */}
//         <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
//           <p>
//             © {currentYear} Wisdom Consultancy. All Rights Reserved.
//           </p>

//           <div className="flex gap-5">
//             <Link
//               to="/privacy-policy"
//               className="hover:text-white transition-colors"
//             >
//               Privacy Policy
//             </Link>

//             <Link
//               to="/terms"
//               className="hover:text-white transition-colors"
//             >
//               Terms & Conditions
//             </Link>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClock,
  FaWhatsapp,
  FaGoogle,
} from 'react-icons/fa';
import { motion } from 'framer-motion';

const logoImage = '/images/logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Financial Calculators', path: '/calculators' },
    { name: 'Blogs', path: '/blogs' },
    { name: 'Contact Us', path: '/contact' },
  ];

  // Updated according to client requirement
  const services = [
    'Mutual Funds',
    'Health Insurance',
    'Life Insurance',
    'Car & Bike Insurance',
    'Home Loans',
    'Wealth Planning',
  ];

  const socialLinks = [
    {
      icon: <FaFacebookF />,
      link: 'https://www.facebook.com/profile.php?id=100091949229467',
    },
    {
      icon: <FaInstagram />,
      link: 'https://www.instagram.com/yags007/',
    },
    {
      icon: <FaYoutube />,
      link: 'https://www.youtube.com/@yagneshdole3378',
    },
    {
      icon: <FaWhatsapp />,
      link: 'https://wa.me/919726344477',
    },
    {
      icon: <FaGoogle />,
      link: 'https://share.google/BbsNaz8Fk9VqP3J1u',
    },
  ];

  return (
    <footer className="bg-[#0b1220] text-gray-300 pt-16 pb-6 relative overflow-hidden">
      
      {/* Background Blur */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-green-500/10 rounded-full blur-3xl" />

      <div className="container-custom relative z-10">

        {/* Main Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12 border-b border-white/10">

          {/* COMPANY INFO */}
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link to="/" className="flex items-center gap-4 mb-6">
              
              <div className="w-16 h-16 rounded-2xl bg-white p-2 shadow-lg">
                <img
                  src={logoImage}
                  alt="Wisdom Consultancy"
                  className="w-full h-full object-contain"
                />
              </div>

              <div>
                <h2 className="text-white text-2xl font-bold leading-tight">
                  Wisdom Consultancy
                </h2>

                <p className="text-xs tracking-[3px] text-green-400 uppercase mt-1">
                  Secure Your Future
                </p>
              </div>
            </Link>

            <p className="text-sm leading-8 text-gray-400 mb-6">
              Empowering your financial journey with expert investment,
              insurance, and wealth planning solutions focused on growth,
              protection, and long-term financial confidence.
            </p>

            {/* Social Links */}
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noreferrer"
                  className="w-11 h-11 rounded-full bg-white/10 hover:bg-gradient-to-r hover:from-[#2e56b8] hover:to-[#69bf74] flex items-center justify-center text-white transition-all duration-300 hover:scale-110"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </motion.div>

          {/* QUICK LINKS */}
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            <h3 className="text-white text-2xl font-semibold mb-6">
              Quick Links
            </h3>

            <ul className="space-y-4">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-white transition-all duration-300 text-sm hover:pl-2 inline-block"
                  >
                    → {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* SERVICES */}
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="text-white text-2xl font-semibold mb-6">
              Our Services
            </h3>

            <ul className="space-y-4">
              {services.map((service, index) => (
                <li
                  key={index}
                  className="text-sm text-gray-400 hover:text-white transition-all duration-300"
                >
                  ✓ {service}
                </li>
              ))}
            </ul>

            {/* ARN Box */}
            <div className="mt-8 bg-white/5 border border-white/10 rounded-2xl p-5">
              <h4 className="text-white font-semibold mb-2">
                Mutual Fund Distributor
              </h4>

              <p className="text-sm text-gray-400 leading-7">
                ARN Holder & Financial Consultant providing trusted investment
                guidance and wealth management solutions.
              </p>
            </div>
          </motion.div>

          {/* CONTACT INFO */}
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h3 className="text-white text-2xl font-semibold mb-6">
              Contact Info
            </h3>

            <ul className="space-y-6 text-sm">

              {/* Address */}
              <li className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-[#69bf74] flex-shrink-0">
                  <FaMapMarkerAlt />
                </div>

                <a
                  href="https://maps.google.com"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition-colors leading-7"
                >
                  E-44, Vasant Vihar Society,
                  <br />
                  GIDC - Vadsar Road,
                  <br />
                  Vadodara - 390010
                </a>
              </li>

              {/* Phone */}
              <li className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-[#69bf74]">
                  <FaPhoneAlt />
                </div>

                <div className="space-y-1">
                  <a
                    href="tel:9726344477"
                    className="block hover:text-white transition-colors"
                  >
                    +91 9726344477
                  </a>

                  <a
                    href="tel:9726766777"
                    className="block hover:text-white transition-colors"
                  >
                    +91 9726766777
                  </a>
                </div>
              </li>

              {/* Email */}
              <li className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-[#69bf74]">
                  <FaEnvelope />
                </div>

                <a
                  href="mailto:wisdom2secure@gmail.com"
                  className="hover:text-white transition-colors"
                >
                  wisdom2secure@gmail.com
                </a>
              </li>

              {/* Timing */}
              <li className="flex gap-4">
                <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-[#69bf74] flex-shrink-0">
                  <FaClock />
                </div>

                <div className="leading-7">
                  <p>Mon - Sat : 10:00 AM - 7:00 PM</p>
                  <p>Sunday : Closed</p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 flex flex-col lg:flex-row items-center justify-between gap-5">

          {/* <p className="text-sm text-gray-500 text-center lg:text-left leading-7">
            © {currentYear} Wisdom Consultancy. All Rights Reserved.
            <br className="block lg:hidden" />
            Empowering Your Financial Journey with Expert Solutions.
          </p> */}

          <p className="text-sm text-gray-500 text-center lg:text-left leading-7">
  © {currentYear} Wisdom Consultancy. All Rights Reserved.
  <br className="block lg:hidden" />
  
  Designed & Developed by{' '}
  
  <a
    href="https://www.qubnixtechnology.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-[#2b57b5] font-semibold hover:underline"
  >
    Qubnix Technology
  </a>
</p>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
            <Link
              to="/privacy-policy"
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </Link>

            <Link
              to="/terms"
              className="hover:text-white transition-colors"
            >
              Terms & Conditions
            </Link>

            <a
              href="https://share.google/BbsNaz8Fk9VqP3J1u"
              target="_blank"
              rel="noreferrer"
              className="hover:text-white transition-colors"
            >
              Google Reviews
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="mt-8 border-t border-white/10 pt-6">
          <p className="text-xs text-gray-500 leading-7 text-center">
            Mutual Fund investments are subject to market risks. Please read all
            scheme related documents carefully before investing. Insurance is
            the subject matter of solicitation. Terms and conditions apply.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;